import bridge from "@/api/bridge";
import cloud from "@/api/cloud";

import _ from "lodash";
import { get, set } from "@/utils/vuex";

const state = () => ({
	community: null,
	rooms: [],	// paired locks
	selectedRoom: null,
	locks: [],	// nearby locks
	users: [],	// for access list
	staff: [],	// for access list
	credentials: null,
	account: null,
	key: null,
});

const FIND_TIMEOUT = 10;
const CONNECT_TIMEOUT = 30;

const getters = {
	loggedIn: state => !!state.credentials,
	community: (s, g, rs, rootGetters) => rootGetters["session/community"],
	rooms: get("rooms"),
	locks: get("locks"),
	users: get("users"),
	staff: get("staff"),
	creds: get("credentials"),
	account: get("account"),
	key: get("key"),
	selected: get("selectedRoom"),
};

const mutations = {
	setCommunity: set("community"),
	setRooms: set("rooms"),
	setRoom: set("selectedRoom"),
	setLocks: set("locks"),
	setUsers: set("users"),
	setStaff: set("staff"),
	setCredentials: set("credentials"),
	setAccount: set("account"),
	setKey: set("key"),

	matchUsers(state) {
		const { users, staff } = state;
		if (!users.length || !staff.length) return;
		state.users = users.map(({ guid, roles }) => ({
			...staff.find(user => user._id === guid),
			guid,
			mode: roles.includes("LockAdmin") ? "admin" : "user",
			roles,
		}));

		state.staff = staff.filter(staff => !~users.findIndex(user => user.guid === staff.guid));
	},

	addRoom(state, room) {
		state.rooms = [...state.rooms, room];
	},

	removeRoom(state, deviceId) {
		state.rooms = state.rooms.filter(room => room.deviceId !== deviceId);
	},

	reset(s) {
		Object.assign(s, state());
	},
};

const actions = {
	async login({ commit }) {
		commit("reset");
		const account = await cloud.locksLogin();
		commit("setAccount", account);

		const { accessKey, secret, allyName, allyToken } = account;
		await bridge.lockInit(accessKey, secret, allyName, allyToken);
	},

	async getRooms({ commit, getters }) {
		const rooms = await cloud.getLocks(getters.community.legacyId);
		commit("setCommunity", getters.community.id);
		commit("setRooms", rooms);
		return rooms;
	},

	async getNearbyLocks({ commit }) {

		const locks = await bridge.lockSearch(FIND_TIMEOUT);
		commit("setLocks", locks);
		return locks;
	},

	async pairLock({ commit }, { deviceId, pinCode }) {
		// await bridge.lockUnpair(deviceId);

		const creds = await bridge.lockPair(deviceId, CONNECT_TIMEOUT, pinCode);
		commit("setCredentials", creds);
	},

	async registerLock({ commit, getters }, { deviceId, roomName }) {
		const communityId = getters.community.id;
		const creds = getters.creds;
		const res = await cloud.addLock(communityId, deviceId, roomName, creds);
		commit("addRoom", res);
		return res;
	},

	async unpairLock({ commit, getters }, deviceId) {
		const communityId = getters.community.id;

		const res = await bridge.lockUnpair(deviceId);
		await cloud.removeLock(communityId, deviceId);
		commit("removeRoom", deviceId);
		return res;
	},

	async checkoutLock({ commit }, deviceId) {
		const res = await cloud.checkoutLock(deviceId);
		commit("setKey", res.key);
		return res;
	},

	async lockRoom({ getters }, deviceId) {
		await bridge.lockConnect(deviceId, CONNECT_TIMEOUT, getters.key);
		return bridge.lockLock(deviceId, getters.key);
	},

	async unlockRoom({ getters }, deviceId) {
		await bridge.lockConnect(deviceId, CONNECT_TIMEOUT, getters.key);
		return bridge.lockUnlock(deviceId, getters.key);
	},

	async getUsers({ commit, getters }) {
		if (getters.users.length) return getters.users;
		let users = await cloud.getLockUsers(getters.community.id);
		commit("setUsers", users);
		commit("matchUsers");

		return users;
	},

	async getStaff({ commit, getters }) {
		if (getters.staff.length) return getters.staff;
		let staff = await cloud.getAssociationUsers(getters.community.id);

		staff = _.filter(staff, ({_type}) => _type == 'staff' || _type == 'vendor');
		staff = staff.map(user => ({
			...user,
			name: `${_.get(user, "firstName", "")} ${_.get(user, "lastName", "")}`
		}));

		commit("setStaff", staff);
		commit("matchUsers");

		return staff;
	},

	async addUser({ commit, getters }, _user) {
		console.log(_user);
		const res = await cloud.addLockUser(_user);

		const user = getters.staff.find(staff => staff._id === _user._id);

		const users = [...getters.users, { ...user, mode: _user.admin ? "admin" : "user" }];
		commit("setUsers", users);

		const staff = getters.staff.filter(staff => staff._id !== user._id);
		commit("setStaff", staff);

		return res;
	},

	async removeUser({ commit, getters }, user) {
		const res = await cloud.removeLockUser(user._id);

		const staff = [...getters.staff, user];
		commit("setStaff", staff);

		const users = getters.users.filter(u => u._id !== user._id);
		commit("setUsers", users);

		return res;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
